import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['notifications'],
  byCustomerId: (payload: { customerId: string }): QueryKey => [...queryKeys.all, payload.customerId],
};
